import React from 'react';
import { useBranding } from '../theme/use-branding';
interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  className?: string;
}
export const Logo: React.FC<LogoProps> = ({
  size = 'md',
  showText = true,
  className = ''
}) => {
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-10 w-10',
    lg: 'h-12 w-12'
  };
  const { branding } = useBranding();
  const src = branding.logoUrl && branding.logoUrl !== '' ? branding.logoUrl : '/ChatGPT_Image_17._Juli_2025%252C_13_53_28.png';
  const title = branding.companyName || 'SIDIGO';
  return <div className={`flex items-center gap-2 ${className}`}>
      <img src={src} alt={title} className={`${sizeClasses[size]} object-contain`} />
      {showText && <span className="text-xl font-bold">{title}</span>}
    </div>;
};